import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import withTranslation from 'next-translate/withTranslation'
import { Page, PageHeader, AddPageContent, Page404 } from '../src/ui'
import { Router as AdsAddRouter } from '../src/modules/ads/add/router'
import { fetchCategory, fetchSpecifications } from '../src/modules/categories/actions'
import { fetchEquipment } from '../src/modules/ads/equipment/actions'
import { fetchBrands } from '../src/modules/ads/brands/actions'
import { fetchServices } from '../src/modules/ads/services/actions'
import { fetchCountries } from '../src/modules/geoObjects/countries/actions'
import { fetchCitiesByCountryWithinRegions } from '../src/modules/geoObjects/cities/actions'
import { fetchLocations } from '../src/modules/geoObjects/locations/actions'
import { getCurrentSubCategory } from '../src/modules/categories/selectors'
import { AdApi } from '../src/modules/ads/shared/api'
import { fetchCategories } from '../src/modules/categories/actions'
import { setPackages } from '../src/modules/ads/add/actions'
import { getIsAuthorized } from '../src/modules/users/Auth/selectors'
import { getUserInfo } from '../src/modules/users/Profile/selectors'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.json'

const addAdFormChooseCategoryText = 'Izaberite kategoriju oglasa za predmet koji prodajete...'
const addAdFormDescriptionText = 'Izabrali ste kategoriju oglasa, sada popunite podatke u poljima ispod, da što bolje opišete predmet koji prodajete.'

class AddAdPage extends React.Component {
  static async getInitialProps ({store, req, query}) {
    const categorySeo = query.category

    let category = null
    let isPageExists = false

    console.log('query add ad ', query)

    await store.dispatch(fetchCategories({ locale: query?.locale?.toUpperCase() || 'ME' }))

    if (categorySeo) {
      const options = { seo: categorySeo, locale: query?.locale?.toUpperCase() || 'ME' }

      await store.dispatch(fetchCategory(options, false))
      category = getCurrentSubCategory(store.getState())

      if (category && category.id) {
        isPageExists = true

        await Promise.all([
          store.dispatch(fetchSpecifications(category.id, query?.locale?.toUpperCase() || 'ME')),
          store.dispatch(fetchEquipment(category.id, query?.locale?.toUpperCase() || 'ME')),
          store.dispatch(fetchBrands(category.id)),
          store.dispatch(fetchCountries(query?.locale?.toUpperCase() || 'ME')),
          store.dispatch(fetchServices(query?.locale?.toUpperCase() || 'ME'))
        ])

        const api = new AdApi()
        const packages = await api.getPackageList()
        store.dispatch(setPackages(packages))

        const isAuthorized = getIsAuthorized(store.getState())

        if (isAuthorized) {
          const userInfo = getUserInfo(store.getState())
          // Get geo data from user
          const userMainAddress = userInfo && Array.isArray(userInfo.userAddresses) ? userInfo.userAddresses[0] : null

          if (userMainAddress && userMainAddress.country && userMainAddress.city) {
            await Promise.all([
              store.dispatch(fetchCitiesByCountryWithinRegions(Number(userMainAddress.country.id))),
              store.dispatch(fetchLocations(Number(userMainAddress.city.id), category.id))
            ])
          }
        }
      }
    } else {
      isPageExists = true
    }

    return {
      title: category && category.title
        ? `${config.pages.addAd.title} - ${category.title} | ${config.siteName}`
        : isPageExists ? `${config.pages.addAd.title} | ${config.siteName}` : config.pages.notFoundTitle,
      category: categorySeo,
      isPageExists,
      state: AddAdPage.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo

      if (isPageExists) {
        state.categories.currentSubcategory = currentState.categories.currentSubcategory
        state.categories.sort = currentState.categories.sort
        state.categories.filters = currentState.categories.filters
        state.categories.specifications = currentState.categories.specifications
        state.categories.similarWords = currentState.categories.similarWords

        state.ads.equipment = currentState.ads.equipment
        state.ads.brands = currentState.ads.brands
        state.ads.services = currentState.ads.services

        state.ads.add.packages = currentState.ads.add.packages

        state.geoObjects.countries = currentState.geoObjects.countries
        state.geoObjects.regions = currentState.geoObjects.regions
        state.geoObjects.cities = currentState.geoObjects.cities
        state.geoObjects.locations = currentState.geoObjects.locations

        state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
        state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas
      }
    }

    return state
  }

  render () {
    const { isPageExists, category, i18n: { t } } = this.props

    return isPageExists
      ? <Page>
        <PageHeader>{t(`common:${config.pages.addAd.headerTitle}`)}</PageHeader>
        <AddPageContent
          title={t(`common:${config.pages.addAd.title}`)}
          description={
            category
              ? t(`common:addAdFormDescriptionText`)
              : t(`common:addAdFormChooseCategoryText`)
          }
          descriptionClass={category ? 'heading-lead' : ''}
        >
          <AdsAddRouter category={category} />
        </AddPageContent>
      </Page>
      : <Page404 />
  }
}

AddAdPage.propTypes = {
  category: PropTypes.string,
  isPageExists: PropTypes.bool.isRequired
}

AddAdPage.defaultProps = {
  isPageExists: false
}

export default withTranslation(AddAdPage)
